import Layout from './Layout';
const EffectIcons = ({ icon }) => {
  return <Layout
    icon={icon}
  />;
};
export default EffectIcons;
